module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4004-4a347287e38d1329432f78eac6b566e4.jpg";